module.exports = __webpack_public_path__ + "static/media/logo-inverse.ddd4e4ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-inverse.png
// module id = 118
// module chunks = 7